const config = {
  ENVIRONMENT_NAME: 'dev',
  forwoodId: {
    URL: 'https://id.dev.dlpocclient.forwoodsafety.com',
    USER_TOKEN_URL: 'https://mmos819k0c.execute-api.us-west-2.amazonaws.com/prod'
  },
  apiGateway: {
    REGION: 'us-west-2',
    URL: 'https://l7v2d3d4h8.execute-api.us-west-2.amazonaws.com/prod'
  },
  reactApp: {
    VERSION: 'teams-container-1.11.7',
    HOSTNAME: 'https://teams.dev.dlpocclient.forwoodsafety.com',
    TEAMS_MICROFRONTEND_URL: 'https://teams-service.dev.dlpocclient.forwoodsafety.com',
    TARGETS_MICROFRONTEND_URL: 'https://targets.dev.dlpocclient.forwoodsafety.com',
    TEAMS_ACCESS_ROLE: 'TeamsAccess',
    TEAM_TARGETS_ACCESS_ROLE: 'TeamTargetsAccess',
  },
  configurationService: {
    URL: 'https://config.dev.dlpocclient.forwoodsafety.com',
    WEBSOCKET: 'wss://9ltq2u61yc.execute-api.us-west-2.amazonaws.com/dev'
  },
  get forwoodIdAuthUrl() {
    return `${this.forwoodId.URL}/authorize?response_type=token&scope=openid&client_id=${this.forwoodId.APP_CLIENT_ID}&redirect_uri=${this.reactApp.HOSTNAME}&state=`;
  }
};

export default config;
